// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CrossRateData } from '@shared/utils/CrossRate/CrossRateData';
import { DirectCrossRateMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class CrossRateMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const AssetDecodeMap = this.decoder.AssetDecodeMap;
        const crossRateGroups = fieldSet.GetGroups(FieldsFactory.CROSS_GROUP);
        const res = [];
        for (const crg of crossRateGroups) {
            const crd = new CrossRateData();
            res.push(crd);
            const asset2Id = crg.GetValue(FieldsFactory.FIELD_ASSET_ID2);
            if (isNullOrUndefined(asset2Id)) {
                crd.Exp1 = crg.GetValue(FieldsFactory.FIELD_NAME_EXP1);
                crd.Exp2 = crg.GetValue(FieldsFactory.FIELD_NAME_EXP2);
            }
            else {
                // новая схема, когда вместо строки передается ID
                const asset1Id = crg.GetValue(FieldsFactory.FIELD_ASSET_ID);
                crd.Exp1 = AssetDecodeMap[asset1Id] || null;
                crd.Exp2 = AssetDecodeMap[asset2Id] || null;
            }
            crd.Price = crg.GetValue(FieldsFactory.FIELD_PRICE);
            crd.Bid = crg.GetValue(FieldsFactory.FIELD_BID);
            crd.Ask = crg.GetValue(FieldsFactory.FIELD_ASK);
            crd.DefaultPriceType = crg.GetValue(FieldsFactory.FIELD_PRICE_TYPE_FOR_RISK);
            const instId = crg.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
            crd.InstrumentId = !isNullOrUndefined(instId) ? instId.toString() : null;
            crd.InstrumentTypeId = crg.GetValue(FieldsFactory.FIELD_INSTRUMENTTYPE_ID);
            crd.PointSize = crg.GetValue(FieldsFactory.FIELD_POINTSIZE);
            crd.IsReverse = crg.GetValue(FieldsFactory.FIELD_TYPE);
            const nestedGroup = crg.GetGroups(FieldsFactory.CROSS_GROUP);
            if (isValidArray(nestedGroup)) {
                const ncrd = new CrossRateData();
                for (const ncrg of nestedGroup) {
                    ncrd.IsReverse = ncrg.GetValue(FieldsFactory.FIELD_TYPE);
                    ncrd.PointSize = ncrg.GetValue(FieldsFactory.FIELD_POINTSIZE);
                    const instId = ncrg.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
                    ncrd.InstrumentId = !isNullOrUndefined(instId) ? instId.toString() : null;
                    ncrd.InstrumentTypeId = ncrg.GetValue(FieldsFactory.FIELD_INSTRUMENTTYPE_ID);
                    ncrd.Bid = ncrg.GetValue(FieldsFactory.FIELD_BID);
                    ncrd.Ask = ncrg.GetValue(FieldsFactory.FIELD_ASK);
                }
                crd.SecondCrossRateData = ncrd;
            }
        }
        return [new DirectCrossRateMessage(res)];
    }
}
